/* 9/26 night: cart F1, F2, F7, F8 — the cart had no JavaScript at all.
   A quantity change needed a second tap on a 13px grey link below the Checkout button, and
   pressing Enter in the quantity field submitted the checkout with the old quantity.
   This file: commits a quantity on change, blocks Enter from reaching Checkout, keeps the
   subtotal, the per-line prices, the saving and the free-shipping line in step, and relabels
   the size line the way the product page labels it. */
(() => {
  'use strict';
  const root = document.querySelector('[data-mw-cart]');
  if (!root) return;
  const form = document.getElementById('mw-cart-form');
  const threshold = Number(root.dataset.freeThreshold) || 15000;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Midwood?.currency || 'USD'
  }).format(cents / 100);

  /* ---- size label, read the way the product page reads it (cart F7) ---- */
  document.querySelectorAll('[data-cart-size]').forEach(el => {
    const mapper = window.MidwoodSizeMapper;
    const raw = el.dataset.raw || '';
    const optName = el.dataset.optname || '';
    if (!mapper || !raw) return;
    if (!mapper.sizeOptionName(optName)) return;
    const mapped = mapper.mapOption(raw, {
      title: el.dataset.title || '',
      vendor: el.dataset.vendor || '',
      handle: el.dataset.handle || '',
      type: el.dataset.type || '',
      tags: (el.dataset.tags || '').split(','),
      sizeLocale: el.dataset.locale || '',
      optionNames: [optName]
    });
    if (mapped && mapped.storefront_label) el.textContent = mapped.storefront_label;
  });

  if (!form) return;
  const status = form.querySelector('[data-cart-status]');
  const updateButton = form.querySelector('[data-cart-update]');
  if (updateButton) updateButton.hidden = true;

  function say(text) { if (status) status.textContent = text || ''; }

  function paint(cart) {
    const subtotal = form.querySelector('[data-cart-subtotal]');
    if (subtotal) subtotal.textContent = money(cart.total_price);
    document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = String(cart.item_count); });

    let saving = 0;
    form.querySelectorAll('[data-cart-row]').forEach(row => {
      const line = Number(row.dataset.line);
      const item = cart.items[line - 1];
      if (!item) return;
      /* compare-at is not in the cart JSON; the row carries the variant's MSRP */
      const msrp = Number(row.dataset.compareUnit) || 0;
      const compareUnit = msrp > Number(item.final_price) ? msrp : 0;
      const compareLine = compareUnit ? compareUnit * item.quantity : 0;
      const priceEl = row.querySelector('[data-line-price]');
      const compareEl = row.querySelector('[data-line-compare]');
      const saveEl = row.querySelector('[data-line-save]');
      if (priceEl) priceEl.firstChild.textContent = money(item.final_line_price);
      if (compareEl) { compareEl.hidden = compareLine === 0; if (compareLine) compareEl.textContent = money(compareLine); }
      if (saveEl) {
        const gap = compareLine ? compareLine - item.final_line_price : 0;
        saveEl.hidden = gap <= 0;
        if (gap > 0) saveEl.textContent = `Save ${money(gap)}`;
      }
      if (compareLine) saving += compareLine - item.final_line_price;
    });

    const savingRow = form.querySelector('[data-cart-saving]');
    const savingValue = form.querySelector('[data-cart-saving-value]');
    if (savingRow) { savingRow.hidden = saving <= 0; if (saving > 0 && savingValue) savingValue.textContent = money(saving); }

    const ship = form.querySelector('[data-cart-shipping]');
    if (ship) ship.textContent = cart.total_price >= threshold
      ? 'Free shipping applied'
      : `Add ${money(threshold - cart.total_price)} more for free shipping · $8 shipping under $150`;

    const heading = root.querySelector('.mw-page-head h1');
    if (heading) heading.textContent = cart.item_count > 0 ? `Your bag (${cart.item_count})` : 'Your bag';
  }

  let busy = false;
  async function commit(input) {
    if (busy) return;
    const row = input.closest('[data-cart-row]');
    if (!row) return;
    const line = Number(row.dataset.line);
    const quantity = Math.max(0, Math.floor(Number(input.value) || 0));
    busy = true;
    say('Updating your bag…');
    try {
      const response = await fetch((window.Midwood?.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity }),
        credentials: 'same-origin'
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'We could not change that quantity.');
      /* A removed line renumbers every line below it, so reload rather than guess. */
      if (cart.item_count === 0 || cart.items.length !== form.querySelectorAll('[data-cart-row]').length) {
        location.assign((window.Midwood?.root || '/') + 'cart');
        return;
      }
      input.value = String(cart.items[line - 1].quantity);
      paint(cart);
      say('Bag updated.');
    } catch (error) {
      say(error.message || 'We could not change that quantity. Try again.');
    } finally {
      busy = false;
    }
  }

  form.querySelectorAll('[data-cart-qty]').forEach(input => {
    input.addEventListener('change', () => commit(input));
  });

  /* Enter inside the quantity field used to fire the first submit button, which is Checkout. */
  form.addEventListener('keydown', event => {
    if (event.key !== 'Enter') return;
    if (!event.target.matches('[data-cart-qty]')) return;
    event.preventDefault();
    commit(event.target);
  });
})();
